import { cn } from "../lib/cn";

export interface LiveIndicatorProps {
  active?: boolean;
  color?: string;
  size?: number;
  className?: string;
}

export function LiveIndicator({
  active = true,
  color = "var(--color-success)",
  size = 6,
  className,
}: LiveIndicatorProps) {
  return (
    <span
      role="status"
      aria-label="Live"
      className={cn(
        "inline-block rounded-full",
        active && "animate-[livePulse_2s_ease-in-out_infinite]",
        active && "motion-reduce:animate-none",
        className,
      )}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
      }}
    />
  );
}
